import { __assign } from "tslib";
import { customJsApiRelativePath, createCustomJsApi, customJsApiRelativePathV2 } from './index';
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from '../../../test-utils';
export var createCustomJsApiApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createCustomJsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetCustomJs: function (brandId) {
            return createFakeGetResponder(fakeHttp, "" + customJsApiRelativePath + (brandId ? "?brandId=" + brandId : ''));
        },
        whenUpdateCustomJs: function (dto) {
            return createFakePutResponder(fakeHttp, "" + customJsApiRelativePath)(dto.data);
        },
        whenGetCustomJsV2: function (brandId) {
            return createFakeGetResponder(fakeHttp, "" + customJsApiRelativePathV2 + (brandId ? "?brandId=" + brandId : ''));
        },
        whenUpdateCustomJsV2: function (dto) {
            return createFakePutResponder(fakeHttp, "" + customJsApiRelativePathV2)(dto.data);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map